import { Controller, Control, RegisterOptions } from 'react-hook-form';
import { MarketCheckbox, MarketRow } from '@market/react';

export const CHECKBOX_TEST_ID = 'checkbox-test-id';
export const ROW_TEST_ID = 'row-test-id';

type ControlledCheckboxProps = {
  // fields used by the controller
  control: Control;
  defaultValue?: boolean;
  name: string;
  rules?: RegisterOptions;
  shouldUnregister?: boolean;

  // fields used by Market components, there are more that are not listed here
  // visit go/marketstorybook to see all available components and their props
  label?: string;
  disabled?: boolean;
  controlPosition?: HTMLMarketRowElement['controlPosition'];
  onValueChange: (_value: boolean) => void;

  // the rules prop is not used if a custom resolver is provided
  useResolver?: boolean;
};

const ControlledCheckbox = ({
  control,
  defaultValue = false,
  name,
  rules = {},
  shouldUnregister = false,
  label,
  disabled = false,
  controlPosition,
  onValueChange,
  useResolver = false,
}: ControlledCheckboxProps) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      shouldUnregister={shouldUnregister}
      {...(!useResolver && { rules })}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState: { isSubmitting },
      }) => (
        <MarketRow
          data-testid={ROW_TEST_ID}
          interactive
          controlPosition={controlPosition}
          onMarketRowSelected={() => {
            onChange(true);
            onValueChange(true);
          }}
          onMarketRowDeselected={() => {
            onChange(false);
            onValueChange(false);
          }}
          disabled={disabled || isSubmitting}
          selected={value}
        >
          <MarketCheckbox
            slot="control"
            data-testid={CHECKBOX_TEST_ID}
            {...(value && { checked: true })}
            {...(Boolean(error) && { invalid: true })}
          />
          {label}
        </MarketRow>
      )}
    />
  );
};

export default ControlledCheckbox;
